import { Group } from '@mantine/core';
import { UserRole } from '@repo/common/enums/UserRole';
import { Title } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import {
	NavBarBreadcrumbWrapper,
	NavBarRightSideWrapper,
	NavBarWrapper,
} from '.';
import { useFeatureFlags } from '../../../utils/featureFlags';
import AddMonitorButton from '../../AddMonitor/AddMonitorButton';
import { Guard } from '../../Guard/Guard';

function MonitorsPageNavBar() {
	const { aiSuggestionsEnabled } = useFeatureFlags();
	return (
		<NavBarWrapper>
			<NavBarBreadcrumbWrapper>
				<Group>
					<Title order={1} size="sm" data-testid="monitors-page-nav-bar-title">
						Monitors
					</Title>
				</Group>
			</NavBarBreadcrumbWrapper>
			<NavBarRightSideWrapper>
				{/* <Guard
					v1AllowedRoles={[UserRole.ADMIN, UserRole.EDITOR]}
					v2Permission="Monitors.Create"
				>
					{aiSuggestionsEnabled && (
						<ShowSuggestionsButton
							suggestionType={{
								gen_type: 'monitors_for_workspace',
							}}
						/>
					)}
				</Guard> */}
				<Guard
					v1AllowedRoles={[UserRole.ADMIN, UserRole.EDITOR]}
					v2Permission="Monitors.Create"
				>
					<AddMonitorButton />
				</Guard>
			</NavBarRightSideWrapper>
		</NavBarWrapper>
	);
}

const ObservedMonitorsPageNavBar = observer(MonitorsPageNavBar);
export default ObservedMonitorsPageNavBar;
